import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Address = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    company: "",
    fullName: "",
    phone: "",
    pincode: "",
    locality: "",
    address: "",
    city: "",
    state: "",
    country: "India",
    billingSame: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCheckout = () => {
    for (const key in form) {
      if (!form[key] && key !== "company") {
        toast.error(`Please fill ${key}`);
        return;
      }
    }
    toast.success("Address saved successfully!");
    localStorage.setItem("shippingAddress", JSON.stringify(form));
    navigate("/checkout");
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        {/* Left Side */}
        <div style={styles.left}>
          <h2 style={styles.heading}>Add Shipping Address</h2>

          <input name="company" value={form.company} onChange={handleChange} placeholder="Company's Name (Optional)" style={styles.input} />

          <div style={styles.row}>
            <input name="fullName" value={form.fullName} onChange={handleChange} placeholder="Name" style={styles.input} />
            <input name="phone" type="number" value={form.phone} onChange={handleChange} placeholder="Phone Number" style={styles.input} />
          </div>

          <div style={styles.row}>
            <input name="pincode" type="number" value={form.pincode} onChange={handleChange} placeholder="Pincode" style={styles.input} />
            <input name="locality" value={form.locality} onChange={handleChange} placeholder="Locality / Area" style={styles.input} />
          </div>

          <textarea name="address" value={form.address} onChange={handleChange} placeholder="Address (Area and Street)" style={{ ...styles.input, height: "80px" }} />

          <div style={styles.row}>
            <input name="city" value={form.city} onChange={handleChange} placeholder="City/District/Town" style={styles.input} />
            <input name="state" value={form.state} onChange={handleChange} placeholder="State" style={styles.input} />
          </div>

          <div style={styles.checkboxRow}>
            <input type="checkbox" name="billingSame" checked={form.billingSame} onChange={handleChange} />
            <label style={{ fontSize: "14px", color: "#333" }}>Same as Billing Address</label>
          </div>

          <button onClick={handleCheckout} style={styles.greenBtn}>Save and Deliver here</button>
        </div>

        {/* Right Side */}
        <div style={styles.right}>
          <div style={{ borderBottom: "1px dashed #ccc", paddingBottom: "20px", marginBottom: "20px" }}>
            <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#333" }}>Order Summary</h3>
          </div>

          <div style={styles.summaryRow}><span>Order Total</span><span>Rs. 2766</span></div>
          <div style={styles.summaryRow}><span>Delivery Charges</span><span>Rs. 150</span></div>

          <div style={{ borderTop: "1px dashed #ccc", margin: "20px 0" }}></div>

          <div style={{ fontSize: "15px", fontWeight: "600", marginBottom: "10px" }}>Delivery Summary</div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div style={{ fontSize: "14px" }}>Standard Delivery</div>
              <div style={{ fontSize: "12px", color: "#777" }}>Expected on 21 May, 2025</div>
            </div>
            <div style={{ fontWeight: "600" }}>Rs 120</div>
          </div>

          <div style={styles.summaryRow}><span>Total Payable</span><span style={{ fontWeight: "700", fontSize: "18px" }}>Rs. 4300</span></div>

          <button onClick={handleCheckout} style={styles.redBtn}>Place Order</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    background: "#e9eff4",
    padding: "40px 0",
  },
  container: {
    maxWidth: "1200px",
    margin: "auto",
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
  },
  left: {
    flex: 1,
    minWidth: "300px",
    padding: "20px",
    boxSizing: "border-box",
  },
  right: {
    flex: "0 0 350px",
    minWidth: "280px",
    padding: "20px",
    backgroundColor: "#fff",
    margin: "0 auto",
    boxSizing: "border-box",
  },
  heading: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#1d2b53",
    marginBottom: "30px",
  },
  input: {
    flex: 1,
    padding: "12px 14px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "15px",
    marginBottom: "16px",
    background: "#fff",
    width: "100%",
    boxSizing: "border-box",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    gap: "12px",
    flexWrap: "wrap",
  },
  checkboxRow: {
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  summaryRow: {
    fontSize: "15px",
    fontWeight: "600",
    display: "flex",
    justifyContent: "space-between",
    marginTop: "14px",
    color: "#333",
  },
  greenBtn: {
    background: "#3a8df5",
    color: "#fff",
    padding: "14px",
    border: "none",
    width: "100%",
    borderRadius: "4px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
  },
  redBtn: {
    background: "#000",
    color: "#fff",
    padding: "14px",
    border: "none",
    width: "100%",
    borderRadius: "4px",
    fontSize: "15px",
    fontWeight: "600",
    marginTop: "30px",
    cursor: "pointer",
  },
};

export default Address;
